import { X } from "lucide-react";
import { Button } from "../../../components/ui/button-new";
import { cn } from "@/lib/utils";

interface RemovableTagProps {
    children: React.ReactNode;
    onDelete: () => void;
    isReadOnly?: boolean;
    disabled?: boolean;
}

export function RemovableTag({
    children,
    onDelete,
    isReadOnly = false,
    disabled = false,
}: RemovableTagProps) {
    return (
        <div
            className={cn(
                "min-h-8 p-0 bg-black text-white rounded-full flex flex-row items-center gap-1 transition-all duration-200",
                isReadOnly ? "px-4" : "hover:bg-neutral-700 pl-4 pr-1",
            )}
        >
            <span className="font-normal text-base/tight text-nowrap">
                {children}
            </span>
            {!isReadOnly && (
                <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8 p-0 hover:text-white hover:scale-110 transition-all duration-200 rounded-full"
                    onClick={onDelete}
                    disabled={disabled}
                >
                    <X className="size-5" />
                </Button>
            )}
        </div>
    );
}
